\:host
    width: 100%

.InputWrapperDefault
    position: relative
    height: 40px
    width: 100%
    box-sizing: border-box
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    border-radius: 0 $globalButtonRounding $globalButtonRounding $globalButtonRounding
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    &:hover
        border: 1px solid rgb($globalSettingsStrokePrimary)
    &:focus-within
        border: 1px solid rgb($globalSettingsStrokePrimary)
    &.FixedStyle
        border: 1px solid rgb(215, 215, 220)
        border-radius: 0 5px 5px 5px
        box-shadow: 1px 3px 8px 0 rgba(215, 215, 215, 0.05), -1px 3px 8px 0 rgba(215, 215, 215, 0.05)
        &:hover
            border: 1px solid rgb(208, 208, 214)
        &:focus-within
            border: 1px solid rgb(208, 208, 214)

.HiddenInput
    border-radius: $globalButtonRounding
    width: 0.1px
    height: 0.1px
    padding: 0
    opacity: 0
    overflow: hidden
    position: absolute
    z-index: -1
    &.FixedStyle
        border-radius: 5px

.InputWrapperDefaultWithFileUpload
    position: relative
    height: 40px
    width: 100%
    box-sizing: border-box
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    border-radius: $globalButtonRounding
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    &:hover
        border: 1px solid rgb($globalSettingsStrokePrimary)
    &:focus-within
        border: 1px solid rgb($globalSettingsStrokePrimary)
    input + label
        cursor: pointer
        padding: 12px
        display: flex
        align-items: center
        justify-content: center
        height: 100%
        width: 100%
        gap: 10px
        span
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
    input:focus-visible + label
        outline: 1px dotted #000 !important
        outline: -webkit-focus-ring-color auto 5px !important
    &.FixedStyle
        border: 1px solid rgb(215, 215, 220)
        border-radius: 5px
        box-shadow: 1px 3px 8px 0 rgba(215, 215, 215, 0.05), -1px 3px 8px 0 rgba(215, 215, 215, 0.05)
        &:hover
            border: 1px solid rgb(208, 208, 214)
        &:focus-within
            border: 1px solid rgb(208, 208, 214)

.InputWrapperSimple
    position: relative
    padding: 0
    min-width: 0
    display: flex
    justify-content: space-between
    align-items: center
    flex-grow: 1
    input
        height: 2em
        padding: 2px
        border-radius: 0
        background: white

.InputWrapperOrder
    height: 40px
    align-items: flex-end
    input
        height: 20px
    .ConfigLabel
        position: absolute
        top: 0
        left: 0
        height: 20px
        display: flex
        justify-content: center
        align-items: center
        background: white
        font-size: 12px
        font-weight: 700
        color: rgb( 97, 95, 115)
        cursor: default
        z-index: 1

.InputWrapperConfig
    position: relative
    height: 80px
    width: 100%
    padding: 0 15px
    border-top: 1px solid rgb(222, 222, 226)
    background-color: rgb(255,255,255)
    font-size: 14px
    font-weight: 400
    color: rgb(97, 95, 115)
    stroke: rgb(97, 95, 115)
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    gap: 10px
    &:hover
        border-top: 1px solid rgb(208, 208, 214)
        background-color: rgb(245,245,245)
        color: rgb(70, 67, 91)
        stroke: rgb(70, 67, 91)
    .ConfigTextContainer
        min-width: 0
        display: flex
        flex-direction: column
        flex: 1
        justify-content: center
        .ConfigLabel
            font-size: 12px
            font-weight: 700
            color: rgb( 97, 95, 115)
            cursor: default
        input
            height: 2em
            padding: 0 2px
            border-radius: 0
            background: white
.InputWrapperOrder.Error
    input
        outline: 1px solid rgb(255, 0, 102) !important

.InputWrapperNewConfig
    height: 100%
    border-top: 0
    &:hover
        border-top: 0
        background-color: #fff

input:not([type=file]) + label
    position: absolute
    font-size: 12px
    top: -1em
    left: 0
    height: 1em
    line-height: 1em
    z-index: 1
    display: inline-block
    vertical-align: text-top
    padding: 0 2px 0 0
    font-weight: 700
    color: rgb($globalSettingsFontTertiary)
    white-space: nowrap
    user-select: none
    border-bottom: 1px solid rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box
    &:hover
        border: 1px solid rgb($globalSettingsStrokePrimary)
    &:focus
        outline: none
        border: 1px solid rgb($globalSettingsFontTertiary)
    &.FixedStyle
        color: rgb(125, 123, 140)
        border-bottom: 1px solid rgb(255, 255, 255)
        &:hover
            border: 1px solid rgb(208, 208, 214)
        &:focus
            border: 1px solid rgb(125, 123, 140)

.Touched.LabelError
    color: rgb($globalErrorBackground) !important
    &.FixedStyle
        color: rgb(255, 0, 102) !important

input
    position: relative
    box-sizing: border-box
    padding: 12px
    margin: 0
    height: 100%
    width: 100%
    background-color: rgb($globalSettingsBackgroundPrimary)
    border: none
    border-radius: 0 $globalButtonRounding $globalButtonRounding $globalButtonRounding
    color: rgb($globalSettingsFontPrimary)
    &.FixedStyle
        background-color: rgb(255, 255, 255)
        border-radius: 0 5px 5px 5px
        color: rgb(70, 70, 91)
.Touched.Error
    border: 1px solid rgb($globalErrorBackground) !important
    &.FixedStyle
        border: 1px solid rgb(255, 0, 102) !important
input:disabled
    background-color: #f4f4f4 !important

